import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import { states } from '@/constants/lifecycle';
import LinkCell from '@/components/table/LinkCell';
import SelectableRow from '@/components/table/SelectableRow';
import UserRoleCell from '../../components/UserRoleCell';
import UserNameCell from '../../components/UserNameCell';

const UsergroupUserRow = ({
  allowRemove,
  allowRoleLink,
  allowUserLink,
  category,
  code,
  destroyStatus,
  isDuplicate,
  lastItem,
  removeUser,
  user,
}) => (
  <SelectableRow
    className="aridhia-usergroup-user-row"
    error={user.archived}
    label={user.name}
    warning={!user.archived && !user.approved}
  >
    <UserNameCell user={user} asLink={allowUserLink} />
    <LinkCell title={user.name} value={user.email} />
    <UserRoleCell asLink={allowRoleLink} role={user.role} roleFilter={false} />
    {allowRemove && !isDuplicate && (
      <Table.Cell collapsing>
        <RowDeleteButton
          dataPosition={lastItem ? 'top right' : undefined}
          disabled={destroyStatus === states.PENDING}
          entity="user.group"
          floated="right"
          onClick={() => removeUser(category, code, user.id)}
        />
      </Table.Cell>
    )}
  </SelectableRow>
);

const mapStateToProps = (
  { auth: { currentUser, role: { permissions: { users, roles } } } },
  { user },
) => ({
  allowRoleLink: roles.read,
  allowUserLink: users.read || user.uuid === currentUser.id,
});

export default connect(mapStateToProps)(UsergroupUserRow);
